import { render, staticRenderFns } from "./Outsourcing.vue?vue&type=template&id=166e7973"
import script from "./Outsourcing.vue?vue&type=script&lang=js"
export * from "./Outsourcing.vue?vue&type=script&lang=js"
import style0 from "./Outsourcing.vue?vue&type=style&index=0&id=166e7973&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports